//SearchResults.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as GetSearchResults from "./GetSearchResults";
import * as ResultsFS from "../Util/ResultsFS";
import * as Search from "./Search";
import * as SearchPaging from "./SearchPaging";
import * as SearchResultsHeading from "./SearchResultsHeading";
import * as Settings from "../Settings";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Util_MUI from "../Util/Util_MUI";
import * as WidgetHeading from "../Widgets/WidgetHeading";
import * as Widgets from "../Widgets/Widgets";

import { Paper, TextField, Typography } from "@mui/material";

import React from "react";

const toolName: string = "Search Results";
let scrolling: boolean = false;
let append: boolean;  //True if scrolling to append more records.
const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";

//Clear this tool.
export function clearTool() {
   GetSearchResults.clearAllResults();
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of SearchResults Render");

   let resultsVisible: boolean = true;
   if (DrawerMenu.curToolName !== toolName) {
      resultsVisible = false; //Hide the results if fading out.
   }

   let lay: Search.iLayer = null;
   if (resultsVisible) {
      lay = Search.layers[Search.activeLayerIndex];
   }

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Component did update.
   React.useEffect(() => {
      Spinner.hide(); //Hide the spinner for all search modes.
      Util.logMsg("SearchResults did update");
   });

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Results layer changed.
   function resultsLayerChanged(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
      const layer = Search.layers[event.target.value] as Search.iLayer;
      Util_App.setActiveLayer(layer.name);
      refresh();
      Widgets.setPosition();
   }

   //Show more left panel records when scrolling to bottom.
   function handleScroll(event: React.UIEvent<HTMLDivElement>) {
      if (!resultsVisible) {
         return; //Quit if fading out.
      }
      const target = event.currentTarget;
      const percent: number = (target.scrollTop / (target.scrollHeight - target.clientHeight)) * 100;
      const prevNumRec: number = lay.numRec;

      if (percent > 98) {
         lay.numRec = Math.min((lay.endRec - lay.begRec) + 1, lay.numRec + Settings.maxSearchRecPerPage);
         if (lay.numRec > prevNumRec) {

            if (Spinner.busy) {
               return;
            }
            Spinner.show();
            scrolling = true;
            setTimeout(function () { refresh(); }, 100); //Wait for spinner to render.
         }
      }
   }

   //Build result layers list.
   const resultLayers: string[] = [];
   const resultIndexes: number[] = [];

   if (resultsVisible) {
      for (let i = 0; i < Search.layers.length; i++) {
         const layer: Search.iLayer = Search.layers[i];

         let label: string = layer.name;
         if (layer.name === Search.activeLayer) {
            label = "[" + layer.name + "]"; //Highlight active layer in dropdown.
         }
         const subTot: string = Util.formatTextValue(layer.totRec, "Comma");
         label += " (" + subTot + ")";

         resultLayers.Add(label);
         resultIndexes.Add(i);
      }
   }

   //Tool title.
   let title: string = toolName;
   const numTot: string = Util.formatTextValue(Search.grandTotRec, "Comma");

   if (Search.layers.length === 1) {
      title += " (" + numTot + " " + Search.layers[0].name + ")";

   } else if (Search.grandTotRec > 1) {
      title += " (" + numTot + " total)";
   }

   //Set scrolling and paging status.
   append = false;
   if (scrolling) {
      append = true;
      scrolling = false;
   }

   //Set results to selected layer name.
   let results: ResultsFS.iResult[];

   if (resultsVisible) {
      results = [{
         toolName: toolName, layerName: lay.name, fs: lay.fs, IDs: lay.IDs, begRec: lay.begRec, numRec: lay.numRec, layerNameVisible: false, append: append,
      }];
   }

   //if (lay.fs && (lay.IDs.length > Settings.maxSearchRecPerPage)) {
   let pagingVisible: boolean = false;
   if (lay && lay.fs && (lay.IDs.length > 1)) {
      pagingVisible = true;
   }

   let layerNamesVisible: boolean = false;
   if (lay && Search.layers.length > 1) {
      layerNamesVisible = true;
   }

   //Styling.
   const styles: Default.iStyles = {
      resultsDiv: { overflow: "auto", marginTop: 7 },
   };

   return (
      <Paper>
         <WidgetHeading.Render title={title} onClose={close} />

         <div style={Default.styles.appToolDiv}>
            {resultsVisible && <SearchResultsHeading.Render />}

            {layerNamesVisible && <div style={{ marginTop: 7, marginLeft: 7, marginRight: 7 }}>

               <Typography variant="body1" style={{ margin: 10 }}>
                  <i>Show results for:</i>
               </Typography>

               <TextField select fullWidth
                  label="Layer Name"
                  title="Choose results to show"
                  slotProps={{
                     htmlInput: { id: "search-results-map-layers" },
                     inputLabel: { htmlFor: "search-results-map-layers" }
                  }}
                  value={Search.activeLayerIndex}
                  onChange={resultsLayerChanged}
                  variant="outlined"
                  color="info"
               >
                  {Util_MUI.buildSelectMenuItems(resultLayers, resultIndexes)}
               </TextField>

            </div>}

            {pagingVisible && <SearchPaging.Render />}

            <div id={scrollDivID} style={styles.resultsDiv} onScroll={handleScroll}>
               {resultsVisible && <ResultsFS.Render results={results} />}
            </div>
         </div>

      </Paper>
   ); //end return.

} //end function.
